export const rncpConstante = Object.freeze({
  RNCP_STATUS_DISABLE: 1,
  RNCP_STATUS_ENABLE: 2,
  RNCP_STATUS_SUCCESS: 3,
  RNCP_LEVEL_NIV3: "3",
  RNCP_LEVEL_NIV4: "4",
  RNCP_LEVEL_NIV5: "5",
  RNCP_LEVEL_NIV6: "6",
  RNCP_LEVEL_NIV7: "7",
  RNCP_LEVEL_NIV8: "8",
});
